import { Injectable } from '@angular/core';
import { BigCommerceModeStateService } from '@app/core/services/bigcommerce-mode-state.service';
import { NavGroup } from '@app/modules/nav/models/interfaces/nav-group.interface';
import { NavItem } from '@app/modules/nav/models/interfaces/nav-item.interface';
import { SurfaceNavGroupService } from '@app/modules/nav/services/surface-nav-group.service';

/**
 * This service stores the navigation items that the user is allowed to see and interact with.
 * This list is set once on database load, and is unset when there is no database selected (ex: accounts or databases list pages).
 */
@Injectable({
    providedIn: 'root'
})
export class NavStateService {
    private _navGroups: NavGroup[] = [];

    get navGroups(): NavGroup[] {
        return this._navGroups;
    }

    constructor(
        private readonly bigCommerceSelfService: BigCommerceModeStateService,
        private readonly surfaceNavGroupService: SurfaceNavGroupService
    ) { }

    public clearNavGroups(): void {
        this._navGroups = [];
    }

    public setNavigationGroups(): void {
        let navGroups: NavGroup[] = [];

        if (this.bigCommerceSelfService.showRestrictedUI()) {
            navGroups = this.surfaceNavGroupService.getSurfaceNavGroups();
        } else {
            // todo: add FDX Classic nav groups structure here
        }

        this._navGroups = this.filterByPermissions(navGroups);
    }

    /**
     * Filter out the Nav Groups and Sub Nav items that do not meet permissions
     * @param navGroups
     */
    public filterByPermissions(navGroups: NavGroup[]): NavGroup[] {
        return navGroups
            .filter((navGroup: NavGroup) => this.meetsRequiredPermissions(navGroup))
            .map((navGroup: NavGroup) => {
                return {
                    ...navGroup,
                    children: navGroup.children?.filter((subNav: NavItem) => this.meetsRequiredPermissions(subNav))
                };
            });
    }

    /**
     * Checks permissions for the NavGroup and NavItems
     * @param nav
     * @private
     */
    private meetsRequiredPermissions(nav: NavItem): boolean {
        // todo: add check feature flags and other permissions here when needed

        if (typeof (nav.requiredPermissions.hasPermission) === 'function') {
            return nav.requiredPermissions.hasPermission();
        }

        return true;
    }
}
